import { connect as unistoreConnect } from '../store/unistore/combined/react';
import * as R from 'ramda';

// TODO memoize this
function connect(mapStateToProps, actions) {
    function middlewareStateToProps(state, props) {
        const userClientId = R.path(['user', 'selectedUserClientId'], state);
        const currentClientState =
            R.path(['clients', userClientId], state) || {};

        const selectedClientId = R.path(['user', 'selectedClientId'], state);
        const currentClient =
            R.path(['user', 'clientsById', selectedClientId], state) || {};

        if (Array.isArray(mapStateToProps)) {
            const newState = mapStateToProps.reduce((acc, key) => {
                if (key === 'user') {
                    acc[key] = state.user;
                    return acc;
                }

                if (key === 'client') {
                    acc[key] = currentClient;
                    return acc;
                }

                acc[key] = currentClientState[key];
                return acc;
            }, {});

            return newState;
        }

        return mapStateToProps(
            {
                ...currentClientState,
                user: state.user,
                client: currentClient,
            },
            props,
        );
    }

    return function(Component) {
        return unistoreConnect(middlewareStateToProps, actions)(Component);
    };
}

export default connect;
